import moment from 'moment';
import firebase from '../config/firebase.config';
import map from 'lodash/map';
import { reject } from 'lodash';
import httpClient from '../config/httpClient';
import { monthMap, months } from '../utils/calenderUtils';
const database = firebase.firestore();

const secondsToHoursMinutes = (totalSeconds) => {
  const safe = Math.max(0, Math.floor(Number(totalSeconds) || 0));
  const totalMinutes = Math.floor(safe / 60);
  return { hours: Math.floor(totalMinutes / 60), minutes: totalMinutes % 60 };
};

function getMemberTimes(teamId, memberId, day) {
  // console.log(memberId, teamId);
  return database
    .collection('memberData')
    .doc(teamId)
    .collection('daysData')
    .doc(memberId)
    .collection('dateId')
    .doc(day)
    .get()
    .then((response) => {
      let data;
      if (response.exists) {
        const docData = response.data();
        data = docData;
        console.log(data, 'MEMBER DATA ');
        return {
          success: true,
          data: data,
        };
      } else {
        return {
          success: false,
          data: data,
        };
      }
    })
    .catch((error) => {
      return {
        success: false,
        data: error,
      };
    });
}
function getMemberTableData(teamId, memberId, day) {
  return database
    .collection('memberData')
    .doc(teamId)
    .collection('tableData')
    .doc(memberId)
    .collection('dateId')
    .doc(day)
    .get()
    .then((response) => {
      let data;
      if (response.exists) {
        const docData = response.data();
        data = docData;
        return {
          success: true,
          data: { data, day },
        };
      } else {
        return {
          success: false,
          data: data,
        };
      }
    })
    .catch((error) => {
      return {
        success: false,
        data: error,
      };
    });
}
async function getMemberWeekTimes(teamId, memberId, week) {
  const year = moment().isoWeekYear();
  const weekId = `${week}-${year}`;

  try {
    // Check accumulator first. JS comparison on the stored weekId decides
    // which source to use — no extra query to check existence.
    const accSnap = await database
      .collection('memberData')
      .doc(teamId)
      .collection('accumulator')
      .doc(memberId)
      .get();

    if (accSnap.exists) {
      const accWeek = (accSnap.data() || {}).week;
      if (accWeek?.weekId === weekId) {
        const idle = secondsToHoursMinutes(accWeek.idleSec);
        const productive = secondsToHoursMinutes(accWeek.productiveSec);
        const total = secondsToHoursMinutes(accWeek.totalSec);
        const totalSec = accWeek.totalSec || 0;
        const productiveSec = Math.max(0, accWeek.productiveSec || 0);
        const productivityPercentage =
          totalSec > 0
            ? Math.round((productiveSec / totalSec) * 10000) / 100
            : 0;
        return {
          success: true,
          data: {
            weekId,
            idleHours: idle.hours,
            idleMinutes: idle.minutes,
            productiveHours: productive.hours,
            productiveMinutes: productive.minutes,
            totalHours: total.hours,
            totalMinutes: total.minutes,
            productivityPercentage,
            screenshotCount: accWeek.screenshotCount || 0,
            appUsage: accWeek.appUsage || {},
          },
        };
      }
    }

    // Accumulator doesn't hold this week; fall back to permanent storage.
    const weekSnap = await database
      .collection('memberData')
      .doc(teamId)
      .collection('weeksData')
      .doc(memberId)
      .collection('weekId')
      .doc(weekId)
      .get();

    if (!weekSnap.exists) {
      return { success: false, data: undefined };
    }
    return { success: true, data: weekSnap.data() };
  } catch (error) {
    return { success: false, data: error };
  }
}

async function getMemberTimeData(teamId, memberId, day) {
  return database
    .collection('memberData')
    .doc(teamId)
    .collection('daysData')
    .doc(memberId)
    .collection('dateId')
    .doc(day)
    .get()
    .then((response) => {
      let data;
      if (response.exists) {
        const docData = response.data();
        data = docData;
        return {
          success: true,
          data: data,
        };
      } else {
        return {
          success: false,
          data: data,
        };
      }
    })
    .catch((error) => {
      return {
        success: false,
        data: error,
      };
    });
}

async function getMemberWeekTimeData(teamId, memberId, week) {
  return database
    .collection('memberData')
    .doc(teamId)
    .collection('lastWeekData')
    .doc(memberId)
    .collection('weekId')
    .doc(week)
    .get()
    .then((response) => {
      let data;
      if (response.exists) {
        const docData = response.data();
        data = docData;
        return {
          success: true,
          data: data,
        };
      } else {
        return {
          success: false,
          data: data,
        };
      }
    })
    .catch((error) => {
      return {
        success: false,
        data: error,
      };
    });
}

async function getMemberMonthTimeData(teamId, memberId, month) {
  return database
    .collection('memberData')
    .doc(teamId)
    .collection('lastMonthData')
    .doc(memberId)
    .collection('monthId')
    .doc(month)
    .get()
    .then((response) => {
      let data;
      if (response.exists) {
        const docData = response.data();
        data = docData;
        return {
          success: true,
          data: data,
        };
      } else {
        return {
          success: false,
          data: data,
        };
      }
    })
    .catch((error) => {
      return {
        success: false,
        data: error,
      };
    });
}

async function getDateRangeTimeDataMember(start, end, teamId, userId) {
  console.log(start, end, teamId, 'getDateRangeTimeDataMember');
  try {
    const response = await httpClient.post('/dateRangeForMember', {
      start,
      end,
      teamId,
      userId,
    });
    const res = response.data;
    console.log('data in getDateRangeTimeDataMember', res.result);
    if (res.success) {
      return { success: true, data: res.result };
    }
    return { success: false, data: res.message };
  } catch (err) {
    console.log(err);
    return { success: false, data: err };
  }
}

//   async function getMemberTimelog

async function getMemberTimeLog(teamID) {
  const snapshot = await database
    .collection('teamDatabase')
    .doc(teamID)
    .collection('members')
    .get();

  let data = [];
  if (!snapshot.empty) {
    const promiseAr = [];

    snapshot.forEach((doc) => {
      promiseAr.push(
        database
          .collection('teamDatabase')
          .doc(teamID)
          .collection('members')
          .doc(doc.id)
          .collection('days')
          .get()
      );
    });

    const aa = await Promise.all(promiseAr);

    aa.forEach((res) => {
      res.forEach((d) => {
        data.push({
          ...d.data(),
          date: d.id,
        });
      });
    });
    return {
      success: true,
      data,
    };
  } else {
    return { success: true, data: [] };
  }
}

async function getAllMemberData(
  teamID,
  activeTeamMembers,
  yearIds = [],
  startDate,
  endDate
) {
  // Create an array of dates from startDate to endDate
  const dateArray = [];

  let currentMonth,
    monthWiseDateMap = {};
  while (startDate <= endDate) {
    const temp = startDate.getMonth();
    const monthId = `${
      months[startDate.getMonth()]
    }-${startDate.getFullYear()}`;
    if (currentMonth !== temp) {
      currentMonth = temp;
      monthWiseDateMap[monthId] = [];
    }
    monthWiseDateMap[monthId].push(startDate.toLocaleDateString('en-GB')); // Format date as dd/mm/yyyy
    startDate.setDate(startDate.getDate() + 1); // Increment date by one day
  }

  const nonChicagoTeamMembers = [],
    chicagoTeamMembers = [];

  // activeTeamMembers.forEach((member)=>{
  //   if(member?.timeZone ==="America/Chicago"){
  //     chicagoTeamMembers.push(member);
  //   } else {
  //     nonChicagoTeamMembers.push(member);
  //   }
  // })

  // Collecting all promises
  const fetchPromises = yearIds.map(async (month) => {
    const memberData = await Promise.all(
      activeTeamMembers.map((member) => {
        return database
          .collection('memberData')
          .doc(teamID)
          .collection('daysData')
          .doc(member?.userUID)
          .collection('attendanceData')
          .doc(month)
          .get()
          .then((response) => {
            const memberData = {
              id: member?.userUID,
              name: member?.userName,
              data: {},
            };
            // Populate data for each date
            monthWiseDateMap[month].forEach((date) => {
              const formatDate = date.replace(/\//g, ':');
              if (response?.data()?.[formatDate]) {
                memberData.data[formatDate] = response.data()[formatDate];
              } else {
                memberData.data[formatDate] = {}; // Return empty object if no data
              }
            });
            return memberData;
          })
          .catch((err) => {
            // Return empty data if there's an error
            const memberData = {
              id: member?.userUID,
              name: member?.userName,
              data: {},
            };
            monthWiseDateMap[month].forEach((date) => {
              memberData.data[date] = {}; // Populate with empty data
            });
            return { ...memberData, error: err };
          });
      })
    );
    return { [month]: memberData };
  });

  const allTimeZoneData = [];
  // const formattedDates = dateArray.map(date=>{
  //   const localDate = date.split("/");
  //   const day = Number(localDate[0]);
  //   const month = Number(localDate[1]);
  //   const year = localDate[2];
  //   return `${day}:${month}:${year}`;
  // })

  // const fetchPromises2 = chicagoTeamMembers
  // .map(async (member)=>{
  //   const memberId = member?.userUID
  //   console.log(`Processing member: ${memberId}`);
  //   const daysSnapshot = await database
  //     .collection('teamDatabase')
  //     .doc(teamID)
  //     .collection('members')
  //     .doc(memberId)
  //     .collection('days')
  //     .get();
  //   const userData = [];

  //   const filteredSnapshotDocs = daysSnapshot.docs.filter(
  //     doc=>formattedDates.includes(doc.id)
  //   );

  //   filteredSnapshotDocs.sort((a, b) => {
  //     const dateA = new Date(a.id.split(':').reverse().join('-')); // Convert "1:11:2024" to "2024-11-01"
  //     const dateB = new Date(b.id.split(':').reverse().join('-')); // Convert "2:11:2024" to "2024-11-02"
  //     return dateA - dateB; // Compare the dates
  //   });

  //   for (const dayDoc of filteredSnapshotDocs) {
  //     if (!dayDoc.data()) continue;
  //     const dayData = dayDoc.data();
  //     userData.push(dayData);
  //   }
  //   const data = {
  //     id: memberId,
  //     name: member.userName,
  //     data: userData,
  //   };
  //   allTimeZoneData.push(data);
  //   return data;
  // })
  // Waiting for all fetch operations to complete
  // Promise.all(fetchPromises2).then().catch(err => console.error(err));
  return Promise.all(fetchPromises)
    .then((allData) => {
      return { success: true, data: { allData, allTimeZoneData } }; // This array contains all the data fetched
    })
    .catch((err) => {
      return { success: false, data: [] }; // Return an empty array in case of error
    });
}

async function getMergedAttendanceExcel(teamId, startDate, endDate) {
  try {
    const response = await httpClient.get('/getMergedAttendanceExcel', {
      params: {
        teamId,
        startDate: startDate.toISOString(),
        endDate: endDate.toISOString(),
      },
      responseType: 'blob',
    });
    const blob = response.data;
    const contentDisposition = response.headers['content-disposition'];
    let fileName = 'attendance_data.xlsx';
    if (contentDisposition) {
      const filenameMatch = contentDisposition.match(/filename="(.+)"/);
      if (filenameMatch) {
        fileName = filenameMatch[1];
      }
    }
    return {
      success: true,
      data: {
        blob,
        fileName,
        fileSize: blob.size,
      },
    };
  } catch (error) {
    console.error('Error downloading Excel file:', error);
    return {
      success: false,
      error: error.response?.data?.error || error.message,
    };
  }
}

async function getUserTokenOptionsFromLicenseDB(companyId) {
  try {
    const snapshot = await firebase
      .firestore()
      .collection('licenseDatabase')
      .where('companyId', '==', companyId)
      .get();

    if (snapshot.empty) return [];

    return snapshot.docs.map((doc) => {
      const data = doc.data();
      return {
        label: data.deskId,
        value: data.value,
      };
    });
  } catch (error) {
    console.error('Error fetching user token options:', error);
    throw error;
  }
}

export default {
  getAllMemberData,
  getMemberTimes,
  getMemberWeekTimes,
  getMemberTableData,
  getMemberTimeData,
  getMemberWeekTimeData,
  getMemberMonthTimeData,
  getMemberTimeLog,
  getDateRangeTimeDataMember,
  getMergedAttendanceExcel,
  getUserTokenOptionsFromLicenseDB,
};
